import { render, staticRenderFns } from "./AreaForm.vue?vue&type=template&id=6f7b84df"
import script from "./AreaForm.vue?vue&type=script&lang=js"
export * from "./AreaForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/componenterpserver/gitrepo/unitmodeler/jp-ui/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6f7b84df')) {
      api.createRecord('6f7b84df', component.options)
    } else {
      api.reload('6f7b84df', component.options)
    }
    module.hot.accept("./AreaForm.vue?vue&type=template&id=6f7b84df", function () {
      api.rerender('6f7b84df', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/modules/sys/area/AreaForm.vue"
export default component.exports